import { c as _c } from "react/compiler-runtime";
import type { MissionListItem, MissionStat } from '@module/apis/client-side/mission/type';
import SettingConfig from '@module/config/setting';
import { IcoGradientAlert } from '@module/svg/icons';
import TimeConstants from '@module/utils/item';
import { useEffect, useState } from 'react';
interface MissionTimerProps {
  limitDateTime: MissionListItem['limitDateTime'];
  stat: MissionStat;
  refetchMissionList?: () => void;
}
const calculateTimeRemaining = (time: string | null) => {
  if (!time) return 0;
  const now = new Date();
  const aTime = new Date(time);
  const timeDifference = aTime.getTime() - now.getTime();
  return timeDifference <= 0 ? 0 : timeDifference;
};
// 미션 타이머
export function MissionTimer(t0) {
  const $ = _c(17);
  const {
    limitDateTime,
    stat,
    refetchMissionList
  } = t0;
  const [timeRemaining, setTimeRemaining] = useState(null);
  let t1;
  let t2;
  if ($[0] !== limitDateTime || $[1] !== stat) {
    t1 = () => {
      setTimeRemaining(calculateTimeRemaining(limitDateTime));
      const interval = setInterval(() => {
        const restTime = calculateTimeRemaining(limitDateTime);
        setTimeRemaining(restTime);
        if (restTime <= 0) {
          clearInterval(interval);
        }
      }, 1000);
      if (stat === "success" || stat === "fail") {
        clearInterval(interval);
      }
      return () => {
        clearInterval(interval);
      };
    };
    t2 = [limitDateTime, stat];
    $[0] = limitDateTime;
    $[1] = stat;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[4] !== refetchMissionList || $[5] !== timeRemaining) {
    t3 = () => {
      if (timeRemaining !== null && timeRemaining <= 0 && refetchMissionList) {
        refetchMissionList();
      }
    };
    t4 = [timeRemaining, refetchMissionList];
    $[4] = refetchMissionList;
    $[5] = timeRemaining;
    $[6] = t3;
    $[7] = t4;
  } else {
    t3 = $[6];
    t4 = $[7];
  }
  useEffect(t3, t4);
  if (!limitDateTime) {
    return null;
  }
  if (timeRemaining === null) {
    let t5;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <div>Loading...</div>;
      $[8] = t5;
    } else {
      t5 = $[8];
    }
    return t5;
  }
  const days = Math.floor(timeRemaining / 86400000);
  const hours = Math.floor(timeRemaining % 86400000 / 3600000);
  const minutes = Math.floor(timeRemaining % 3600000 / 60000);
  const hoursReplace = hours < 10 ? `0${hours}` : hours;
  const minutesReplace = minutes < 10 ? `0${minutes}` : minutes;
  if (timeRemaining < 30500) {
    let t5;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <IcoGradientAlert />;
      $[9] = t5;
    } else {
      t5 = $[9];
    }
    const t6 = Math.floor(timeRemaining / 1000);
    let t7;
    if ($[10] !== t6) {
      t7 = <p className="flex w-full flex-row items-center gap-1 text-nowrap text-[#EF312A]">{t5}<span>{t6}초 남았어요</span></p>;
      $[10] = t6;
      $[11] = t7;
    } else {
      t7 = $[11];
    }
    return t7;
  }
  if (timeRemaining <= TimeConstants.ONE_MINUTE) {
    return `${Math.floor(timeRemaining / 1000)}초 남았어요`;
  }
  let t5;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <span>남았어요</span>;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== days || $[14] !== hoursReplace || $[15] !== minutesReplace) {
    t6 = <>{days}일 {hoursReplace}:{minutesReplace} {t5}</>;
    $[13] = days;
    $[14] = hoursReplace;
    $[15] = minutesReplace;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
}

// 미션 상태(성공, 실패) 이미지
export function MissionItemStatus(t0) {
  const $ = _c(2);
  const {
    item
  } = t0;
  const statusImg = _temp;
  const isSuccesFail = item.stat === "success" || item.stat === "fail";
  if (!isSuccesFail) {
    return null;
  }
  const t1 = `${SettingConfig.S3_BUCKET_URL}/img/mission/${statusImg(item.stat)}`;
  let t2;
  if ($[0] !== t1) {
    t2 = <><div className="mission-item-status"><img height={96} width={96} src={t1} alt="mission icon" /></div></>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  return t2;
}

// 대기상태인 경우 남은 대기시간
function _temp(status) {
  switch (status) {
    case "success":
      {
        return "stamp-mission-success.svg";
      }
    case "fail":
      {
        return "stamp-mission-fail.svg";
      }
    case "":
      {
        return "";
      }
    default:
  }
  return "";
}
export const waitTimeLimit = (item: MissionListItem) => {
  if (item.stat !== 'wait') return '';
  // 시작으로부터 1시간 뒤면 자동 종료. 1시간이 되어 자동 종료되기 까지 남은 시간 계산
  const now = new Date();
  const limit = new Date(item.insertDateTime);
  limit.setHours(limit.getHours() + 1);
  const diff = limit.getTime() - now.getTime();
  const min = Math.floor(diff / (1000 * 60));
  if (diff <= 0) return '';
  if (diff <= 1000 * 60) return '1분 내 취소';
  return `${min}분 후 취소`;
};